import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextSportsHeader, {
  SportsHeaderContextType,
} from '@contexts/sportsHeader'
import { MiddleInfoProps } from '@widgets/Teaser/sportsHeader/types'
import { computeTeaserWidth } from '@widgets/Teaser/utils'
import { ViewportTypeValues } from '@contexts/viewport'
import { desktopCSS, tabletCSS, mobileCSS } from '@measures/responsive'

type StyledMiddleInfoProps = Pick<MiddleInfoProps, 'infoTitleShown'> &
  Pick<SportsHeaderContextType, 'teaserFlex' | 'teaserType' | 'isInMegaModule'>

const { SportsHeaderContext } = contextSportsHeader

const StyledMiddleInfo = styled.div<StyledMiddleInfoProps>`
  position: relative;
  display: flex;
  justify-content: center;
  min-width: 20px;
  height: 100%;
  box-sizing: border-box;
  ${({ infoTitleShown, teaserFlex, teaserType, isInMegaModule }) => {
    if (!infoTitleShown) {
      return ``
    }

    let paddingTopDesktop
    const desktopTeaserFlex = teaserFlex['desktop']
    const teaserWidthDesktop = computeTeaserWidth({
      flexValue: desktopTeaserFlex,
      viewportType: ViewportTypeValues.DESKTOP,
    })

    let paddingTopTablet
    const tabletTeaserFlex = teaserFlex['tablet']
    const teaserWidthTablet = computeTeaserWidth({
      flexValue: tabletTeaserFlex,
      viewportType: ViewportTypeValues.TABLET,
    })

    let paddingTopMobile

    if (
      teaserType === 'listitem' ||
      (teaserType === 'standard' && isInMegaModule)
    ) {
      paddingTopDesktop = '10px'
      paddingTopTablet = '10px'
    } else {
      if (desktopTeaserFlex === '6') {
        paddingTopDesktop = `${0.01389 * teaserWidthDesktop}px`
      } else if (desktopTeaserFlex === '4') {
        paddingTopDesktop = `${0.02108 * teaserWidthDesktop}px`
      } else if (desktopTeaserFlex === '3') {
        paddingTopDesktop = `${0.02235 * teaserWidthDesktop}px`
      } else if (desktopTeaserFlex === '2') {
        paddingTopDesktop = `${0.034375 * teaserWidthDesktop}px`
      }

      if (tabletTeaserFlex === '6') {
        paddingTopTablet = `${0.02108 * teaserWidthTablet}px`
      } else if (tabletTeaserFlex === '3') {
        paddingTopTablet = `${0.02235 * teaserWidthTablet}px`
      }
    }

    if (['standard', 'listitem'].includes(teaserType)) {
      paddingTopMobile = '10px'
    } else {
      paddingTopMobile = '2.9334vw'
    }

    return css`
      ${desktopCSS(css`
        padding-top: ${paddingTopDesktop};
      `)}

      ${tabletCSS(css`
        padding-top: ${paddingTopTablet};
      `)}

        ${mobileCSS(css`
        padding-top: ${paddingTopMobile};
      `)}
    `
  }}
`

const MiddleInfo: FunctionComponent<MiddleInfoProps> = ({
  infoTitleShown,
  children,
}) => {
  const { teaserFlex, teaserType, isInMegaModule } =
    useContext(SportsHeaderContext)

  return (
    <StyledMiddleInfo
      infoTitleShown={infoTitleShown}
      teaserFlex={teaserFlex}
      teaserType={teaserType}
      isInMegaModule={isInMegaModule}>
      {children}
    </StyledMiddleInfo>
  )
}

export default MiddleInfo
